<div id="banner-cripto" class="swiper-background d-lg-flex align-items-center pt-5 pt-lg-0">
    <div class="container">
        <div class="row">
            <div class="col-md-11 col-lg-6 col-xl-7">
                <div class="pretitle-container mb-3">
                    <span class="p-display-bold border-y-1 border-primary-900 primary-900">
                        BITCOIN Y ETHEREUM
                    </span>
                </div>
                <h1 class="h1-display primary-900 mb-2">
                    ETFs de <span class="secondary-funds-700">criptomonedas</span>, sin complicaciones
                </h1>
                <p class="p-display primary-900 d-none d-lg-block">
                    Nuestros ETFs te permiten invertir en criptomonedas de forma fácil, segura y eficiente, sin
                    necesidad de manejar activos
                    digitales.
                </p>
            </div>

            <div class="mt-3 mt-lg-4">
                <app-btn-link [linkId]="'btn-banner-cripto-informacion'" [linkTitle]="'Más información'"  [linkUrl]="'criptomonedas'"></app-btn-link>
            </div>
        </div>
    </div>
</div>